import {
    CountryPackageNotAuthPrice,
    CountryPackagePrice,
    CountryPackageZeroPrice,
    DumbCountryPackagePrice
} from "./country_package_price.js";
import CountryPackageBundles from "./country_package_bundles.js";
import {CountryPackageNoPrice, PackageNoPrice} from "./country_package_no_price.js";
import CountryPackageButton from "./country_package_button.js";
import SkeletonLoader from "../skeleton_loader.js";
import {isAboutExpire1, isAboutExpire30, isSourceApp} from "../helper/helpers";
const productSource = catalogModule.getSource();
const hasPackage = catalogModule.hasPackage();
const userOwnPkg = catalogModule.getUsrPkg();
export const CountryPackage = (props) => {
    const [isLoading, setIsLoading] = React.useState(false);
    let productPackage = Object.assign({}, props.productPackage);
    const regExpPackage4_12 = /ch.xample.group.*.plan/
    let isPackage4_12 = regExpPackage4_12.test(productPackage.key);
    let userPackage = catalogModule.userPackage();
    let isWithin30Days;
    let isWithin1Day;
    if(userOwnPkg){
        isWithin30Days = isAboutExpire30(userOwnPkg.expiration_date_ts);
        isWithin1Day = isAboutExpire1(userOwnPkg.expiration_date_ts);
    }
    let isUserPackage4_12 = regExpPackage4_12.test(userPackage.key);
    let isUserPackageFfplum = userPackage.key === "ch.xample.group.ffplum.plan";
    let alreadyBoughtItem = productPackage.hasOwnProperty("expiration_date") && productPackage.status === 'ready';
    let isPremium = productPackage && productPackage.key.toLowerCase().includes('premium') ? '' +
        'best-plan' : null;
    // var cannotBoughtPackage =  subscriptionPrice < 0 || ( !subscribed_package && !already_bought_item && has_package_from_another_country);
    let renderPrice;
    // Show the prices
    if(catalogModule.isAuthenticated()){
        // If prices are not negative
        if( productPackage.hasOwnProperty('price') && productPackage.hasOwnProperty('sponsored_price') && productPackage.price > 0){
            // Check first if user has package
            if(!hasPackage){
                // If sponsored
                if(productPackage.sponsored){
                    renderPrice = <DumbCountryPackagePrice {...props}
                                                           showSponBadge={true}
                                                           showSponMonthPrice={true}
                                                           showMonthPrice={true}
                                                           showActiveText={true}
                                                           showBillAnnually={true} />
                } else {
                    renderPrice = <DumbCountryPackagePrice {...props}
                                                           showMonthPrice={true}
                                                           showActiveText={true}
                                                           showBillAnnually={true} />
                }
            } else {
                // If sources are app don't show prices
                if(isSourceApp(productSource) || productSource === "web"){
                    renderPrice = <PackageNoPrice />;
                } else {
                    if(!isUserPackage4_12){
                        // Show prices only on PAYPAL otherwise the general functionality of subscription
                        if(catalogModule.getSource() === 'paypal'){
                            // renderPrice = <CountryPackagePrice {...props}
                            //                                    showMonthPrice={false}  />
                            renderPrice = <DumbCountryPackagePrice {...props} showSponBadge={false} 
                                                                            showMonthPrice={false}
                                                                            showSponMonthPrice={false}
                                                                            showActiveText={false}
                                                                            showBillAnnually={false} />
                        }
                    } else {
                        // Should get the user package from the list of packages and only on PAYPAL
                        if(isWithin30Days && productSource === "paypal"){
                            // Show different UI text for subscriptions about to expire 1 day
                            if(isWithin1Day){
                                renderPrice = <DumbCountryPackagePrice {...props}
                                                                       showSponBadge={productPackage.sponsored}
                                                                       showMonthPrice={true}
                                                                       showSponMonthPrice={productPackage.sponsored}
                                                                       showActiveText={true}
                                                                       showBillAnnually={true} />
                            } else {
                                // Show different UI text for subscriptions about to expire 30 days
                                if(productPackage.sponsored) {
                                    renderPrice = <DumbCountryPackagePrice {...props}
                                                                           showSponBadge={productPackage.sponsored}
                                                                           showSponMonthPrice={true}
                                                                           showMonthPrice={true}
                                                                           showActiveText={productPackage.buttonRender !== "upgrade"}
                                                                           showBillAnnually={true}
                                                                           showGetItPhrase2={productPackage.buttonRender === "upgrade"} />
                                } else {
                                    renderPrice = <DumbCountryPackagePrice {...props}
                                                                           showMonthPrice={!productPackage.sponsored}
                                                                           showSponMonthPrice={productPackage.sponsored}
                                                                           showActiveText={productPackage.buttonRender !== "upgrade"}
                                                                           showBillAnnually={true}
                                                                           showGetItPhrase2={productPackage.buttonRender === "upgrade"} />
                                }
                            }
                        } else {
                            if(productPackage.buttonRender === "upgrade") {
                                if(productPackage.sponsored){
                                    renderPrice = <DumbCountryPackagePrice {...props}
                                                                           showSponBadge={productPackage.sponsored}
                                                                           showGetItPhrase2={true} />
                                } else {
                                    if(isWithin30Days){
                                        renderPrice = <DumbCountryPackagePrice {...props}
                                                                               showMonthPrice={!productPackage.sponsored}
                                                                               showSponMonthPrice={productPackage.sponsored}
                                                                               showActiveText={false}
                                                                               showBillAnnually={true}
                                                                               showGetItPhrase2={true} />
                                    } else {
                                        if(productSource === "paypal"){
                                            renderPrice = <DumbCountryPackagePrice {...props}
                                                                                   showMonthPrice={false}
                                                                                   showSponMonthPrice={false}
                                                                                   showActiveText={false}
                                                                                   showBillAnnually={false}
                                                                                   showGetItPhrase2={true} />
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // // Don't show prices on app sources
            // if(isSourceApp(productSource)){
            //     renderPrice = <PackageNoPrice />;
            // } else {
            //     if(!isUserPackage4_12){
            //         // Show prices only on PAYPAL otherwise the general functionality of subscription
            //         if(catalogModule.getSource() === 'web' || catalogModule.getSource() === 'apple' || catalogModule.getSource() === 'huawei' || catalogModule.getSource() === 'google'){
            //             renderPrice = <PackageNoPrice />;
            //         } else if(catalogModule.getSource() === 'paypal'){
            //             renderPrice = <CountryPackagePrice productPackage={productPackage}
            //                                                showMonthPrice={false}  />
            //         }
            //     } else {
            //         // Check if source is on web for 4.12 packages and don't show the prices
            //         if(catalogModule.getSource() === 'web'){
            //             renderPrice = <PackageNoPrice />;
            //         } else if(catalogModule.getSource() === 'paypal'){
            //             if(hasPackage){
            //                 if(productPackage.buttonRender === "upgrade"){
            //                     if(productPackage.sponsored){
            //                         renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                showSponBadge={productPackage.sponsored}
            //                                                                showGetItPhrase2={true} />
            //                     } else {
            //                         if(isWithin30Days){
            //                             renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                    showMonthPrice={!productPackage.sponsored}
            //                                                                    showSponMonthPrice={productPackage.sponsored}
            //                                                                    showActiveText={false}
            //                                                                    showBillAnnually={true}
            //                                                                    showGetItPhrase2={true} />
            //                         } else {
            //                             renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                    showMonthPrice={false}
            //                                                                    showSponMonthPrice={false}
            //                                                                    showActiveText={false}
            //                                                                    showBillAnnually={false}
            //                                                                    showGetItPhrase2={true} />
            //                         }
            //                     }
            //                 } else if(productPackage.buttonRender === "current"){
            //                     if(productPackage.sponsored){
            //                         renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                showMonthPrice={false}
            //                                                                showSponMonthPrice={false}
            //                                                                showActiveText={false}
            //                                                                showBillAnnually={false} />
            //                     } else {
            //                         if(isWithin30Days){
            //                             renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                    showMonthPrice={!productPackage.sponsored}
            //                                                                    showSponMonthPrice={productPackage.sponsored}
            //                                                                    showActiveText={true}
            //                                                                    showBillAnnually={true} />
            //                         }
            //                     }
            //                 } else {
            //                     renderPrice = <PackageNoPrice />;
            //                 }
            //             } else {
            //                 if(productPackage.hasOwnProperty('expired') && productPackage.expired === 1){
            //                     if(productPackage.sponsored){
            //                         renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                showMonthPrice={productPackage.sponsored}
            //                                                                showSponMonthPrice={productPackage.sponsored}
            //                                                                showActiveText={true}
            //                                                                showBillAnnually={true} />
            //                     } else {
            //                         renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                showMonthPrice={!productPackage.sponsored}
            //                                                                showSponMonthPrice={productPackage.sponsored}
            //                                                                showActiveText={false}
            //                                                                showBillAnnually={true}
            //                                                                showGetItPhrase2={true} />
            //                     }
            //                 } else {
            //                     if(productPackage.buttonRender === "upgrade"){
            //                         if(productPackage.sponsored){
            //                             renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                    showMonthPrice={productPackage.sponsored}
            //                                                                    showSponMonthPrice={productPackage.sponsored}
            //                                                                    showActiveText={true}
            //                                                                    showBillAnnually={true} />
            //                         } else {
            //                             if(isWithin30Days){
            //                                 renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                        showMonthPrice={!productPackage.sponsored}
            //                                                                        showSponMonthPrice={productPackage.sponsored}
            //                                                                        showActiveText={false}
            //                                                                        showBillAnnually={true}
            //                                                                        showGetItPhrase2={true} />
            //                             } else {
            //                                 renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                        showMonthPrice={!productPackage.sponsored}
            //                                                                        showSponMonthPrice={productPackage.sponsored}
            //                                                                        showActiveText={false}
            //                                                                        showBillAnnually={true}
            //                                                                        showGetItPhrase2={true} />
            //                             }
            //                         }
            //                     } else if(productPackage.buttonRender === "current"){
            //                         if(productPackage.sponsored){
            //                             renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                    showMonthPrice={productPackage.sponsored}
            //                                                                    showSponMonthPrice={productPackage.sponsored}
            //                                                                    showActiveText={true}
            //                                                                    showBillAnnually={true} />
            //                         } else {
            //                             if(isWithin30Days){
            //                                 renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                        showMonthPrice={!productPackage.sponsored}
            //                                                                        showSponMonthPrice={productPackage.sponsored}
            //                                                                        showActiveText={true}
            //                                                                        showBillAnnually={true} />
            //                             }
            //                         }
            //                     } else { // if button is downgrade
            //                         if(productPackage.sponsored){
            //                             renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                    showMonthPrice={productPackage.sponsored}
            //                                                                    showSponMonthPrice={productPackage.sponsored}
            //                                                                    showActiveText={true}
            //                                                                    showBillAnnually={true} />
            //                         } else {
            //                             renderPrice = <DumbCountryPackagePrice productPackage={productPackage}
            //                                                                    showMonthPrice={!productPackage.sponsored}
            //                                                                    showSponMonthPrice={productPackage.sponsored}
            //                                                                    showActiveText={false}
            //                                                                    showBillAnnually={false} />
            //                         }
            //                     }
            //                 }
            //
            //             }
            //         } else {
            //             if(alreadyBoughtItem && (productPackage.buttonRender === 'current' || productPackage.buttonRender === 'downgrade')){
            //                 renderPrice = <PackageNoPrice />;
            //             } else if(productPackage.buttonRender === "upgrade") {
            //                 renderPrice = <CountryPackagePrice productPackage={productPackage}
            //                                                    showMonthPrice={false}
            //                                                    alreadyBoughtItem={alreadyBoughtItem}
            //                                                    isUserPackage4_12={isUserPackage4_12}
            //                                                    isPackage4_12={isPackage4_12} />
            //             } else {
            //                 renderPrice = <PackageNoPrice />;
            //             }
            //         }
            //     }
            // }
        } else {
            if(isSourceApp(productSource)){
                renderPrice = <PackageNoPrice />;
            } else {
                if(!isUserPackage4_12 && catalogModule.getSource() === 'web'){
                    renderPrice = <PackageNoPrice />;
                } else {
                    if(productPackage.hasOwnProperty('price') && productPackage.price === 0){
                        renderPrice = <CountryPackageZeroPrice {...props} />
                    } else {
                        renderPrice = <CountryPackageNoPrice />
                    }
                }

            }
        }
    } else {
        renderPrice = <CountryPackageNotAuthPrice {...props} />
    }

    let cannotBoughtPackage;
    // Check if this package is v4.12
    if(isPackage4_12){
        // Check if user's package is v4.12
        if(isUserPackage4_12) {
            // Check if user's package is special then
            if(isUserPackageFfplum){
                cannotBoughtPackage = false;
            } else {
                cannotBoughtPackage = productPackage.price < 0 || ( !userPackage !== undefined && !alreadyBoughtItem && catalogModule.hasOtherPackage());
            }
        } else {
            // console.log("User special package");
            // Check if user's package is special then
            if(isUserPackageFfplum){
                // Allow to upgrade regular subscriptions
                cannotBoughtPackage = false;
            } else {
                cannotBoughtPackage = false;
            }
        }
    } else {
        cannotBoughtPackage = productPackage.price < 0 || ( !userPackage !== undefined && !alreadyBoughtItem && catalogModule.hasOtherPackage());
    }
    React.useEffect(() => {
        setIsLoading(true)
        setTimeout(() => {
            setIsLoading(false);
        }, 1500)
    }, [])
    // return <CountryPackageBs3 productPackage={productPackage}
    //                           cannotBoughtPackage={cannotBoughtPackage}
    //                           isOffSet={props.isOffSet}
    //                           index={props.index}
    //                           isPackage4_12={isPackage4_12}
    //                           isLoading={isLoading}
    //                           isPremium={isPremium}
    //                           renderPrice={renderPrice} />
    return <CountryPackageBs5 {...props}
                              cannotBoughtPackage={cannotBoughtPackage}
                              index={props.index}
                              isUserPackage4_12={isUserPackage4_12}
                              isPackage4_12={isPackage4_12}
                              isLoading={isLoading}
                              isPremium={isPremium}
                              renderPrice={renderPrice} />
}

// const CountryPackageBs3 = (props) => {
//     let productPackage = props.productPackage;
//     return (
//         <React.Fragment>
//             <div className={`col-lg-4 col-md-4 col-xs-12 col-sm-12 text-center ${props.isOffSet && props.index === 0 ? 'col-md-offset-2 col-lg-offset-2' : ''}`}>
//                 <div className={`panel panel-default has-pkg-overlay ${props.isPremium}`} id={productPackage.key}>
//                     {props.cannotBoughtPackage && <div className="pkg-overlay"></div>}
//                     <div className="panel-body">
//                         {props.isLoading && <SkeletonLoader width={'90%'} height={'60px'} />}
//                         {!props.isLoading && <h2>{productPackage.name}</h2>}
//                         <br/>
//                         {props.isLoading && <SkeletonLoader width={'90%'} height={'105px'} />}
//                         {!props.isLoading && <div className="package_price_container">
//                             {productPackage.sponsored && <h4><span className="label has-bg-primary">{sponsoredText}</span></h4>}
//                             {props.renderPrice}
//                         </div> }
//                         {props.isLoading && <SkeletonLoader width={'90%'} height={'42px'} />}
//                         {
//                             !props.isLoading && <CountryPackageButton productPackage={props.productPackage}
//                                                                       isPackage4_12={props.isPackage4_12} key={props.productPackage.key} />
//                         }
//                     </div>
//                     <CountryPackageBundles productPackage={props.productPackage}
//                                            isLoading={props.isLoading} />
//                 </div>
//             </div>
//         </React.Fragment>
//     )
// }

const CountryPackageBs5 = (props) => {
    let productPackage = props.productPackage;
    return (
        <React.Fragment>
            <div className={`col-lg-4 col-md-4 col-xs-12 col-sm-12 text-center ${props.isOffSet && props.index === 0 ? 'col-md-offset-2 col-lg-offset-2' : ''}`}>
                <div className={`card has-pkg-overlay ${props.isPremium}`} id={productPackage.key}>
                    {props.cannotBoughtPackage && <div className="pkg-overlay"></div>}
                    <div className="card-body">
                        {props.isLoading && <SkeletonLoader width={'90%'} height={'60px'} />}
                        {!props.isLoading && <h2>{productPackage.name}</h2>}
                        <br/>
                        {props.isLoading && <SkeletonLoader width={'90%'} height={'105px'} />}
                        {!props.isLoading && <div className="package_price_container">
                            {/*{productPackage.sponsored && <h4><span className="label has-bg-primary">{sponsoredText}</span></h4>}*/}
                            {props.renderPrice}
                        </div> }
                        {props.isLoading && <SkeletonLoader width={'90%'} height={'42px'} />}
                        {!props.isLoading && <CountryPackageButton {...props} /> }
                    </div>
                    <CountryPackageBundles {...props} />
                </div>
            </div>
        </React.Fragment>
    )
}

export default CountryPackage;

